import { Popover } from 'bootstrap';

export default {
  beforeMount(el, binding) {
    if (binding.value) {
      el._popover = new Popover(el, {
        title: binding.value.title || 'Default Title',
        content: binding.value.content || 'Default Content',
        placement: binding.value.placement || 'top', // Default placement is 'top'
        trigger: 'focus'
      });
    }
  },
  updated(el, binding) {
    if (el._popover) {
      el._popover.dispose();
    }
    if (binding.value) {
      el._popover = new Popover(el, {
        title: binding.value.title || 'Default Title',
        content: binding.value.content || 'Default Content',
        placement: binding.value.placement || 'top',
        trigger: 'focus'
      });
    }
  },
  unmounted(el) {
    if (el._popover) {
      el._popover.dispose();
    }
  }
};
